import { BessChartSeries } from "./BessChartTypes";
import { truncateNumber } from "../../../Utils/NumberUtil";

/**
 * Converte uma série (dateTime[] + value[]) em pares [timestamp, value] para o eixo de tempo do ECharts.
 * Sem interpolação: apenas os pontos reais. Valores com no máximo 2 casas decimais (padrão do projeto).
 */
export const toTimeSeriesData = (series: BessChartSeries): Array<[number, number | null]> => {
    if (!series?.dateTime) return [];
    return series.dateTime.map((t, i) => [new Date(t).getTime(), truncateNumber(series.value[i], 2)]);
};

export const hasPoints = (list: BessChartSeries[]): boolean =>
    Array.isArray(list) && list.some((s) => s.value && s.value.length > 0);

/**
 * Escala do eixo Y do gráfico de Potência, conforme regras da SGD-3676 (Regra 5d + cenários Gherkin):
 *  - considera min/max de todas as séries;
 *  - adiciona margem de 10% (afastando do zero) ao mínimo e ao máximo;
 *  - o zero deve estar sempre visível: se min > -25 fixa em -25; se max < 25 fixa em 25.
 * Ex.: dados [-400, -100] => { min: -440, max: 25 }.
 */
export const computePowerYAxisRange = (list: BessChartSeries[]): { min: number; max: number } => {
    const values = list.flatMap((s) => (s.value ?? []).filter((v) => v !== null && v !== undefined));
    if (values.length === 0) {
        return { min: -25, max: 25 };
    }

    const dataMin = Math.min(...values);
    const dataMax = Math.max(...values);

    let min = dataMin - Math.abs(dataMin) * 0.1;
    let max = dataMax + Math.abs(dataMax) * 0.1;

    // Zero sempre visível (limites mínimos garantidos)
    if (min > -25) min = -25;
    if (max < 25) max = 25;

    return { min: Math.floor(min), max: Math.ceil(max) };
};
